import _ from 'underscore';
import { useMemo, useCallback } from 'react';
import { McaChannelTypes } from '@bingads-webui-campaign-react/mca-core';

import { useMcaData } from './use-mca-data/index';
import { defaultEntityKey } from './common/default-entity-key-selector';

const socialChannelTypes = [
  McaChannelTypes.Facebook,
  McaChannelTypes.Instagram,
  McaChannelTypes.LinkedIn,
  McaChannelTypes.Twitter,
];

const socialChannelTypesFilter = _.chain(socialChannelTypes)
  .map(ct => `ChannelType eq Enum.ChannelType'${ct}'`)
  .join(' or ')
  .value();

const internalChannelTypeFilter = `ChannelType eq Enum.ChannelType'${McaChannelTypes.Internal}'`;

export const useSocialProfiles = (resetOnRefresh = true) => {
  const [entityState, actions] = useMcaData({
    entityName: 'SocialProfile',
    parentEntityName: 'Account',
    entityKey: defaultEntityKey,
    resetOnRefresh,
  });

  const { read, update } = actions;

  const readSocialChannels = useCallback(params => read({
    ...params,
    filter: { where: socialChannelTypesFilter },
  }), [read]);

  const readInternalChannel = useCallback(params => read({
    ...params,
    filter: { where: internalChannelTypeFilter },
  }), [read]);

  const updateInternalChannel = useCallback(params => update({
    ...params,
    filter: { where: internalChannelTypeFilter },
  }), [update]);

  const socialProfileActions = useMemo(() => ({
    ...actions,
    readSocialChannels,
    readInternalChannel,
    updateInternalChannel,
  }), [actions, readSocialChannels, readInternalChannel, updateInternalChannel]);

  return [entityState, socialProfileActions];
};
